import Vue from 'vue';
import {
	DirectiveDefinitionAddFloatingNavSpacer,
	DirectiveDefinitionDisableIfEmbedded,
} from '@customer-portal/shared/src/directives';

Vue.directive('add-floating-nav-spacer', DirectiveDefinitionAddFloatingNavSpacer);
Vue.directive('disable-if-embedded', DirectiveDefinitionDisableIfEmbedded);
